import { payMCopyDateStatusInversed } from '@teinor/erp/types/company/accounting/payMCopy/payMCopyDate'
import ModalSmallFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeniedPaymentMethodCopyDateProps extends ModalEditComponentProps { }

const ModalDeniedPaymentMethodCopyDate: React.FC<ModalDeniedPaymentMethodCopyDateProps> = ({ setOpened, onSubmit, allRowData }) => {
    const {t} = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/config/payment/paymentMethod/changeStatusPaymentMethodCopyDates',
        data: {
            selectedIds: [allRowData?.id],
            status: payMCopyDateStatusInversed['denied']
        }
    })
    return (<ModalSmallFilled opened={true} setOpened={() => { setOpened(null) }} onClickOut={false} onAccept={handleFetchText} translations={{
        title: t('confirmDeniedPayment', 'Confirmar impagado este pago'),
        subtitle:t('sureDeniedPayment', '¿Seguro que quieres impagado este pago?') ,
        buttonAccept: t('accept', 'Aceptar')
    }} />)
}


export default ModalDeniedPaymentMethodCopyDate